<template>
  <el-tag v-if="state && stateLabel" size="medium" :type="cssClass"
    >{{ stateLabel }}
  </el-tag>
</template>

<script>
import constants from "../../../constants";
import hanhChinhUtils from "../../../services/hanhChinhUtils";

export default {
  name: "hc-phonghop-state",
  props: ["state", "isNewFlow", "isLichTuanTo"],

  computed: {
    stateLabel() {
      return hanhChinhUtils.getPhongHopStateLabel(this.state, this.isNewFlow, false, this.isLichTuanTo);
    },

    cssClass() {
      switch (this.state) {
        case constants.HC_STATE.STATE_CODE.PHONG_HOP.HUY:
          return "danger";
        case constants.HC_STATE.STATE_CODE.PHONG_HOP.DA_PHE_DUYET:
          return "success";
        case constants.HC_STATE.STATE_CODE.PHONG_HOP.TU_CHOI:
          return "danger";
        case constants.HC_STATE.STATE_CODE.PHONG_HOP.CHO_LANH_DAO_PHE_DUYET:
          return "warning";
        case constants.HC_STATE.STATE_CODE.PHONG_HOP.CHO_PHE_DUYET:
        default:
          return "";
      }
    }
  },

  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/phonghop/hc-phonghop-state.vue